import { render, staticRenderFns } from "./apply_success.vue?vue&type=template&id=b15d0542&scoped=true"
import script from "./apply_success.vue?vue&type=script&lang=js"
export * from "./apply_success.vue?vue&type=script&lang=js"
import style0 from "./apply_success.vue?vue&type=style&index=0&id=b15d0542&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15d0542",
  null
  
)

export default component.exports